import { EOffersCountActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setOffersCount = actionGenerator<EOffersCountActionType.OffersCountUpdated, number>(
  EOffersCountActionType.OffersCountUpdated,
);
